// extracted by mini-css-extract-plugin
export default {"daysOfWeek":"DaysOfWeek_daysOfWeek__MILK0","dayHeader":"DaysOfWeek_dayHeader__X8as2"};